var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67285 0.333252C0.944948 0.333252 0.339518 0.936575 0.339518 1.66528L0.333008 13.6666L2.99967 10.9999H12.333C13.0617 10.9999 13.6663 10.3953 13.6663 9.66658V1.66659C13.6663 0.937877 13.0617 0.333252 12.333 0.333252H1.67285ZM2.99967 3.66658H4.33301V4.99992H2.99967V3.66658ZM5.66634 3.66658H10.9997V4.99992H5.66634V3.66658ZM2.99967 6.33325H4.33301V7.66658H2.99967V6.33325ZM5.66634 6.33325H10.9997V7.66658H5.66634V6.33325Z",
    fill: "#7A7D80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.216d194d183fb931e1dc040576e29c12.svg";
export { ForwardRef as ReactComponent };